<script setup lang="ts">
import UpsertOrganizationForm from '@/components/forms/organization/UpsertOrganizationForm.vue';
import { ref } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const parentFromRoute = ref(route.params.organizationId?.toString());
</script>

<template>
    <v-fade-transition appear>
        <v-row class="justify-center">
            <v-col lg="6">
                <UpsertOrganizationForm :parent="parentFromRoute" />
            </v-col>
        </v-row>
    </v-fade-transition>
</template>

<style scoped></style>
